// Module
var code = "By continuing browsing, you accept the use of cookies to provide services and offers tailored to your interests. For more information and to set cookies <a class=\"underline cursor-pointer\" data-cy=\"open-cookie-banner\" @click=\"updateModalConfig({ isOpen: true, modalComponent: 'CookiesModal' })\">click here</a>";
// Exports
module.exports = code;